import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import VoiceCampaign from "../../@Components/Data/VoiceCampaign";

const VoiceCampaignPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <VoiceCampaign />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default VoiceCampaignPage;
